export default "__VITE_ASSET__DYluBkJh__"